import { Metric, MetricsKind } from "helpers/metrics/types";

export const isMetricSelected = ({ showValue, showTotals, showSubtotals }: Metric) =>
    showValue || showTotals || showSubtotals;

export const srClientDoorMetricsHash = {
    [MetricsKind.UNIT_ROW_PERCENTAGE_PLAN]: MetricsKind.UNITS,
    [MetricsKind.ROW_PERCENTAGE_PLAN]: MetricsKind.TOTAL_RETAIL,
    [MetricsKind.BREADTH_PERCENTAGE_PLAN]: MetricsKind.PLAN_ROWS,
};

// this temp logic until the backend solves the problem; these are hard limits, not weights
export const srMetricAttributeLimits = {
    [MetricsKind.IMU_PERCENTAGE]: 45,
    [MetricsKind.AUR]: 45,
    [MetricsKind.DOOR_PERCENTAGE_PLAN]: 200,
    [MetricsKind.ROW_PERCENTAGE_PLAN]: 200,
    [MetricsKind.UNIT_DOOR_PERCENTAGE_PLAN]: 225,
    [MetricsKind.UNIT_ROW_PERCENTAGE_PLAN]: 225,
    [MetricsKind.BREADTH_PERCENTAGE_PLAN]: 225,
};

export const CLIENT_DOOR_METRICS = Object.keys(srClientDoorMetricsHash);
export const SERVER_DOOR_METRICS = Object.values(srClientDoorMetricsHash);

const mapSRClientDoorMetric = (metrics: Metric[], metric: Metric) => {
    // client && server in the list -> and is client return undefined
    // client && server in the list -> and is server return merge of both
    // client && !server in the list -> and is client map to server
    // server && !cliente in the list -> and is server return server
    // neither of both client or server  in the list -> return;

    if (CLIENT_DOOR_METRICS.includes(metric.kind)) {
        const severMetric = metrics.find(
            (it) => isMetricSelected(it) && it.kind === srClientDoorMetricsHash[metric.kind]
        );
        if (!severMetric) {
            return {
                ...metric,
                kind: srClientDoorMetricsHash[metric.kind],
            };
        }

        return undefined;
    }

    if (SERVER_DOOR_METRICS.includes(metric.kind)) {
        const clientKind = CLIENT_DOOR_METRICS[SERVER_DOOR_METRICS.findIndex((it) => it === metric.kind)];
        const clientMetric = metrics.find((it) => isMetricSelected(it) && it.kind === clientKind);

        if (clientMetric) {
            return {
                ...metric,
                showValue: metric.showValue ? metric.showValue : clientMetric.showValue,
                showTotals: metric.showTotals ? metric.showTotals : clientMetric.showTotals,
                showSubtotals: metric.showSubtotals ? metric.showSubtotals : clientMetric.showSubtotals,
            };
        }

        return metric;
    }

    return metric;
};

export const hasClientDoorMetrics = (metrics: Metric[]) => {
    return (metrics || []).some((metric) => isMetricSelected(metric) && CLIENT_DOOR_METRICS.includes(metric.kind));
};

export const hasServerDoorMetrics = (metrics: Metric[]) => {
    return (metrics || []).some((metric) => isMetricSelected(metric) && !CLIENT_DOOR_METRICS.includes(metric.kind));
};

export const getDoorMetricsSelected = (metrics: Metric[], preSelectClientMetrics: boolean = false) => {
    return (metrics || []).reduce((acc, metric) => {
        if (isMetricSelected(metric)) {
            const mappedMetric = preSelectClientMetrics ? mapSRClientDoorMetric(metrics, metric) : metric;
            mappedMetric && acc.push(mappedMetric);
        }
        return acc;
    }, []);
};
